<script>
    import ContentBox from "../../layouts/ContentBox.svelte";
    import PageBox from "../../layouts/PageBox.svelte";
    import Button from "../../ui_elements/Button.svelte";
    import InputField from "../../ui_elements/InputField.svelte";
    import SelectField from "../../ui_elements/SelectField.svelte";
    import { onMount } from "svelte";
    import { getQuestionnaire, post } from "../../utility.js";
    import MultiSelectField from "../../ui_elements/MultiSelectField.svelte";
    import GewichtungSelect from "./add-job-components/GewichtungSelect.svelte";
    import SchwerpunktSelect from "./add-job-components/SchwerpunktSelect.svelte";
    import MultiSelectItems from "./add-job-components/MultiSelectItems.svelte";

    let title = {'studiengang': '', 'studiengangAlternative': '', 'studiengangID': '', 'ausbildung': '', 'ausbildungAlternative': '', 'ausbildungID': ''};

    let schwerpunkte = [];
    let interessen = [];
    let schulfaecher = [];
    let faehigkeiten = [];
    let gegenstaende = {};
    let zielgruppen = [];
    let orte = {};

    let subcategories = [];
    let questions = [];

    onMount(async () => {
        const data = await getQuestionnaire();
        subcategories = data.categories.flatMap(category => category.subcategories);
        console.log(subcategories);
        questions = subcategories.flatMap(subcategory => subcategory.questions);
        console.log(questions);
    });

    const submitJob = async () => {
        let job = { 'title': title, 'schwerpunkte': schwerpunkte, 'interessen': interessen, 'schulfaecher': schulfaecher, 'faehigkeiten': faehigkeiten, 'gegenstaende': gegenstaende, 'zielgruppen': zielgruppen, 'orte': orte };
        console.log(job);
        try {
            const data = await post('create-job/', { job });
            console.log(data);
        } catch (error) {
            console.log('Error submitting data:', error);
        }
    }


    function addSchwerpunkt() {
        schwerpunkte = [...schwerpunkte, {'studiengang': '', 'studiengangAlternative': '', 'studiengangID': '', 'ausbildung': '', 'ausbildungAlternative': '', 'ausbildungID': ''}]; 
    }

    function removeSchwerpunkt(index) {
        schwerpunkte = schwerpunkte.filter((_, i) => i !== index);
    }

    function addInteresse() {
        interessen = [...interessen, {'subcategory': '', 'weight': '1', 'schwerpunkt': 'Hauptstudiengang/-ausbildung', 'questionText': ''}];
    }

    function removeInteresse(index) {
        interessen = interessen.filter((_, i) => i !== index);
    }
</script>

<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

<PageBox pageTitle="Neuen Beruf erstellen">    
    <!-- Titel -->
    <ContentBox>
        <div class="text-secondary-text font-bold">Neuer Beruf</div>
        <p>Hinweis: Am besten zuerst eventuelle neue Interessensfragen erstellen und im Anschluss den neuen Beruf erstellen - dann können diese direkt verknüpft werden!</p>

        <p>Falls nur ein Studiengang erstellt werden soll, können die ausbildungsspezifischen Felder leergelassen werden. Dann können aber auch nur Studiengangsschwerpunkte erstellt werden. Analog dazu für das Erstellen einer Ausbildung die studiumsspezifischen Felder leer lassen. </p>
        <p>Für das Erstellen eines Studiengangs und einer dazugehörigen Ausbildung je beide Felder ausfüllen. </p>
        <p>Vor der Erstellung eines neuen Berufs muss ein dazu passender Eintrag auf Berufenet gefunden werden. Die dort vorhandenen Informationen helfen auch bei der Auswahl der Interessensfragen, Schulfächer, Gegenstände etc. Wenn ein passender Beruf gefunden wurde, kann die ID in dem Link der Seite auf Berufenet nachgeschaut werden. Beispiel: Informatik hat den Link https://web.arbeitsagentur.de/berufenet/beruf/93944. Die ID lautet 93944.</p>
        <p>Hinweis: Studienfächer haben meist (grundständig) hinter dem Titel stehen.</p>

        <p>Sofern es auf Berufenet einen Steckbrief zu dem Beruf gibt, wird dieser automatisch nach der Erstellung des neuen Berufs abgefragt und dir angezeigt. Du kannst die verschiedenen Felder dann bearbeiten. Nach deiner Bestätigung wird der Steckbrief mit in die Datenbank gespeichert. </p>
        
        <div class="flex -mx-3 mb-2">
            <InputField bind:value={title.studiengangID} id="studiengangID" label="Studiengang ID" placeholder="Berufenet ID des Studiengangs" width="w-1/3" />
            <InputField bind:value={title.studiengang} id="studiengang" label="Studiengang" placeholder="Bezeichnung des Studiengangs" width="w-2/3" />
            <!-- <InputField bind:value={title.studiengangAlternative} id="studiengangAlternative" label="Optional: Alternativbezeichnung" placeholder="Alternative(n) für den Studiengang" /> -->
        </div>
    
        <div class="flex -mx-3 mb-2">
            <InputField bind:value={title.ausbildungID} id="ausbildungID" label="Ausbildung ID" placeholder="Berufenet ID der Ausbildung" />
            <InputField bind:value={title.ausbildung} id="ausbildung" label="Ausbildung" placeholder="Bezeichnung der Ausbildung" />
            <!-- <InputField bind:value={title.ausbildungAlternative} id="ausbildungAlternative" label="Optional: Alternativbezeichnung" placeholder="Alternative(n) für die Ausbildung" /> -->
        </div>
      </ContentBox>
      
    <!-- Schwerpunkte -->
    <ContentBox>
        <div class="text-secondary-text font-bold mb-4">Schwerpunkte</div>
    
        {#each schwerpunkte as schwerpunkt, index (schwerpunkt)}
          <div class="flex items-start mb-4">      
            <div class="mr-2 font-bold text-gray-700">[{index + 1}]</div>
            <div class="w-full">
              <div class="flex mb-2">
                <InputField bind:value={schwerpunkt.studiengangID} id={"studiengangID" + index} label="Studiengang ID" placeholder="Schwerpunkt: Studiengang ID (Berufenet)" />
                <InputField bind:value={schwerpunkt.studiengang} id={"studiengang" + index} label="Studiengang" placeholder="Schwerpunkt: Studiengang" />
                <!-- <InputField bind:value={schwerpunkt.studiengangAlternative} id={"studiengangAlternative" + index} label="Optional: Alternativen" placeholder="Schwerpunkt: Alternative(n) für den Studiengang" /> -->
              </div>
              <div class="flex mb-2">
                <InputField bind:value={schwerpunkt.ausbildungID} id={"ausbildungID" + index} label="Ausbildung ID" placeholder="Schwerpunkt: Ausbildung ID (Berufenet)" />
                <InputField bind:value={schwerpunkt.ausbildung} id={"ausbildung" + index} label="Ausbildung" placeholder="Schwerpunkt: Ausbildung" />
                <!-- <InputField bind:value={schwerpunkt.ausbildungAlternative} id={"ausbildungAlternative" + index} label="Optional: Alternativen" placeholder="Schwerpunkt: Alternative(n) für die Ausbildung" /> -->
              </div>
            </div>
            <Button on:click={() => removeSchwerpunkt(index)} className="ml-2 text-red-500 hover:text-red-700" variant="ghost" size="icon">
              <i class="fas fa-trash-alt"></i>
            </Button>
          </div>
        {/each}
    
        <Button on:click={addSchwerpunkt} variant="action">
            <i class="fas fa-plus mr-2"></i> Neuen Schwerpunkt hinzufügen
        </Button>
    </ContentBox>
    
    <!-- Interessen -->
    <ContentBox>
        <h2>Interessensfragen</h2>
        
        {#each interessen as interesse, index (interesse)}
          <div class="flex items-start mb-4">      
            <div class="mr-2 font-bold text-gray-700">[{index + 1}]</div>
            <div class="w-full">
              <div class="flex mb-2">
                <SelectField bind:value={interesse.subcategory} id={"interessenSubcategory" + index} label="Subkategorie">
                    {#if subcategories}
                        {#each subcategories.filter(subcategory => subcategory.category_id === 0) as subcategory}
                            <option value={subcategory.subcategory_id}>{subcategory.subcategory_name}</option>
                        {/each}
                    {/if}
                </SelectField>

                <SchwerpunktSelect bind:value={interesse.schwerpunkt} {schwerpunkte} />
                <GewichtungSelect bind:value={interesse.weight} />
              </div>

              <div class="flex mb-2">
                <SelectField bind:value={interesse.questionText} id={"interessenText" + index} label="Question Text" width="">
                    {#if questions}
                        {#if interesse.subcategory != ''}
                            {#each questions.filter(question => question.subcategory_id === interesse.subcategory) as question}
                                <option value={question.question_id}>{question.question_text}</option>
                            {/each}
                        {/if}
                    {/if}
                </SelectField>
              </div>
            </div>
            <Button on:click={() => removeInteresse(index)} className="ml-2 text-red-500 hover:text-red-700" variant="ghost" size="icon">
              <i class="fas fa-trash-alt"></i>
            </Button>
          </div>
        {/each}
    
        <Button on:click={addInteresse} variant="action">
            <i class="fas fa-plus mr-2"></i> Neue Interessensfrage hinzufügen
        </Button>
    </ContentBox>

    <!-- Schulfächer -->
    <ContentBox>
        <h2>Schulfächer</h2>   
        {#if questions}
            {#each subcategories.filter(subcategory => subcategory.category_id === 5) as subcategory}
            <!-- there is some bug that at first an empty list is loaded so we want to skip that -->
                {#if questions.filter(question => question.subcategory_id === subcategory.subcategory_id).length > 0}
                    <MultiSelectField bind:selectedOptions={schulfaecher} id={subcategory.subcategory_name} label={subcategory.subcategory_name} width="" options={questions.filter(question => question.subcategory_id === subcategory.subcategory_id).map(question => question.question_text)} />            
                    <MultiSelectItems selected={schulfaecher} label="Schulfach" {schwerpunkte} />
                {/if}
            {/each}
        {/if}     
       
    </ContentBox>

    <!-- Fähigkeiten -->
    <ContentBox>
        <h2>Fähigkeiten</h2>
        {#if subcategories}
            <MultiSelectField bind:selectedOptions={faehigkeiten} id="faehigkeiten" label="Fähigkeiten" width="" options={subcategories.filter(subcategory => subcategory.category_id === 1).map(subcategory => subcategory.subcategory_name)} />            
            <MultiSelectItems selected={faehigkeiten} label="Fähigkeit" {schwerpunkte} />
        {/if}     
    </ContentBox>

    <!-- Gegenstände -->
    <ContentBox>
        <h2>Gegenstände</h2>
        {#if questions}
            {#each subcategories.filter(subcategory => subcategory.category_id === 4) as subcategory}
            <!-- there is some bug that at first an empty list is loaded so we want to skip that -->
                {#if questions.filter(question => question.subcategory_id === subcategory.subcategory_id).length > 0 && subcategory.subcategory_name != "GegenständeTopThree"}

                    <MultiSelectField bind:selectedOptions={gegenstaende[subcategory.subcategory_name]} id={subcategory.subcategory_name} label={subcategory.subcategory_name} width="" options={JSON.parse(questions.filter(question => question.subcategory_id === subcategory.subcategory_id)[0].question_text.replaceAll("'", '"'))} />            
                        
                    <MultiSelectItems selected={gegenstaende[subcategory.subcategory_name]} label="Gegenstand" {schwerpunkte} />
                {/if}
            {/each}
        {/if}
    </ContentBox>

    <!-- Zielgruppen -->
    <ContentBox>
        <h2>Zielgruppen</h2>
        {#if questions}
        {#each subcategories.filter(subcategory => subcategory.category_id === 3) as subcategory}
        <!-- there is some bug that at first an empty list is loaded so we want to skip that -->
            {#if questions.filter(question => question.subcategory_id === subcategory.subcategory_id).length > 0 && subcategory.subcategory_name != "ZielgruppenTopThree"}
                <MultiSelectField bind:selectedOptions={zielgruppen} id={subcategory.subcategory_name} label={subcategory.subcategory_name} width="" options={JSON.parse(questions.filter(question => question.subcategory_id === subcategory.subcategory_id)[0].question_text.replaceAll("'", '"'))} />            
                <MultiSelectItems selected={zielgruppen} label="Zielgruppe" {schwerpunkte} />
            {/if}
        {/each}
    {/if}

    </ContentBox>

    <!-- Orte -->
    <ContentBox>
        <h2>Orte</h2>
        {#if questions}
            {#each subcategories.filter(subcategory => subcategory.category_id === 7) as subcategory}
            <!-- there is some bug that at first an empty list is loaded so we want to skip that -->
                {#if questions.filter(question => question.subcategory_id === subcategory.subcategory_id).length > 0 && subcategory.subcategory_name != "OrteTopThree"}
                    <MultiSelectField bind:selectedOptions={orte[subcategory.subcategory_name]} id={subcategory.subcategory_name} label={subcategory.subcategory_name} width="" options={JSON.parse(questions.filter(question => question.subcategory_id === subcategory.subcategory_id)[0].question_text.replaceAll("'", '"'))} />            
                    <MultiSelectItems selected={orte[subcategory.subcategory_name]} label="Ort" {schwerpunkte} />
                {/if}
            {/each}
        {/if}
    </ContentBox>

    <Button on:click={submitJob} variant="submit">Beruf erstellen</Button>
    
</PageBox>
